import './loading-page.scss';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { historyActions } from '@/entities/rolls';
import { userActions } from '@/entities/user';
import { selectIsAuthenticated, selectUserLoading } from '@/entities/user';
import { ROUTES } from '@/shared/config/constants';

const FADE_OUT_DURATION_MS = 600;

export const LoadingPage = () => {
  const [progress, setProgress] = useState(0);
  const [isExiting, setIsExiting] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const loading = useAppSelector(selectUserLoading);

  useEffect(() => {
    dispatch(userActions.fetchUserRequest());
    dispatch(historyActions.fetchIfStale());
    const timeout = setTimeout(() => setIsExiting(true), 5000);
    return () => clearTimeout(timeout);
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!loading && isAuthenticated && progress === 100) {
      setIsExiting(true);
    }
  }, [loading, isAuthenticated, progress]);

  useEffect(() => {
    if (!isExiting) return;
    const timeout = setTimeout(() => {
      setIsVisible(false);
      navigate(ROUTES.GAMES, { replace: true });
    }, FADE_OUT_DURATION_MS);
    return () => clearTimeout(timeout);
  }, [isExiting, navigate]);

  if (!isVisible) return null;

  return (
    <div className={`loading-page${isExiting ? ' loading-page--exiting' : ''}`}>
      <div className="loading-page__progress-track">
        <div className="loading-page__progress-fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
